function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Edit Pencil Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.8549,4.1301 L13.8549,7.1301 C14.0499,7.3261 14.0499,7.6421 13.8549,7.8371 L5.8549,15.8371 C5.7999,15.8931 5.7329,15.9341 5.6589,15.9581 L1.1579,17.4581 C1.1059,17.4761 1.0529,17.4841 0.9999,17.4841 C0.8699,17.4841 0.7419,17.4331 0.6459,17.3371 C0.5129,17.2041 0.4659,17.0051 0.5259,16.8261 L2.0269,12.3261 C2.0509,12.2521 2.0929,12.1851 2.1469,12.1301 L10.1469,4.1301 C10.3429,3.9351 10.6589,3.9351 10.8549,4.1301 Z M10.5009,5.1911 L2.9379,12.7541 L1.7909,16.1931 L5.2309,15.0471 L12.7939,7.4841 L10.5009,5.1911 Z M15.4214,0.9225 L17.0744,2.5665 C17.3494,2.8405 17.5004049,3.2035 17.5004049,3.5915 C17.5014,3.9785 17.3494,4.3425 17.0744,4.6165 L15.3574,6.3485 C15.2644,6.4425 15.1374,6.4955 15.0044,6.4965 L15.0024,6.4965 C14.8704,6.4965 14.7444,6.4445 14.6504,6.3505 L11.6494,3.3655 C11.4534,3.1715 11.4524,2.8545 11.6464,2.6585 L13.3664,0.9245 C13.9334,0.3585 14.8554,0.3595 15.4214,0.9225 Z M14.0744,1.6305 L12.7084,3.0085 L15.0004,5.2885 L16.3664,3.9095 C16.4544,3.8225 16.5004,3.7105 16.5004,3.5915 C16.5004,3.4725 16.4544,3.3605 16.3694,3.2755 L14.7164,1.6315 C14.5384,1.4545 14.2504,1.4545 14.0744,1.6305 Z",
  id: "edit-pencil-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "edit-pencil-Icon/Global/Edit",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-pencil-Swatches/DarkGreen",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "edit-pencil-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#edit-pencil-path-1"
})));

var SvgEditPencil = function SvgEditPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-pencil.980df7b9.svg";
export { ForwardRef as ReactComponent };